import toast from 'react-hot-toast'

export const diplayAlert = (message: string) => {
  toast.error(message, {
    duration: 5000,
  })
}
